export default "__VITE_ASSET__saLCDDam__"